<template>
    <div>
        <Loading :value="loading" ></Loading>

        <!--DIALOG FORMULAIRE DEMANDE-->
        <v-dialog v-model="dialogRapport" transition="dialog-bottom-transition" scrollable :loading="loading" max-width="100%" persistent>
            <v-card>
                <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                    <v-toolbar-title>AJOUTER UN RAPPORT JOURNALIER DE CHANTIER TRAVAUX: {{detailTrx.libelle}}  </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click.native="closeDialog()"> <v-icon>close</v-icon> </v-btn>
                </v-toolbar>

                <v-card-text>
                    <v-container fluid grid-list-md>
                        <v-stepper v-model="d1">
                            <v-stepper-header style="flex-wrap: inherit;overflow: visible">
                                <v-stepper-step :complete="d1 > 1" step="1">Date & Conditions Atmosphériques</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :complete="d1 > 2" step="2">Visite Chantier</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :complete="d1 > 3" step="3">Incidents</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :complete="d1 > 4" step="4">Matériaux utilisés</v-stepper-step>                                
                                <v-divider></v-divider>
                                <v-stepper-step :complete="d1 > 5" step="5">Ressources Externes (non prévu)</v-stepper-step>                                
                                <v-divider></v-divider>                             
                                <v-stepper-step :complete="d1 > 6" step="6">Personnels</v-stepper-step>                               
                                <v-divider></v-divider>
                                <v-stepper-step :complete="d1 > 7" step="7">Matériel(s) / Engin(s) affecté(s)</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step  :complete="d1 > 8" step="8">Travaux Réalisés</v-stepper-step>
                                <!-- <v-stepper-step v-if="listeVehicule.length == 0" :complete="d1 > 8" step="7">Travaux Réalisés </v-stepper-step> -->
                            </v-stepper-header>

                            <v-stepper-items>
                                <v-stepper-content step="1">
                                    <v-card>
                                        <el-form label-position="top" :inline="true" :model="formInfo"  ref="formInfo" class="demo-form-inline">
                                            <v-layout row>
                                                <v-flex md3>
                                                    <el-form-item label="Date du rapport" required style="width:100%">
                                                        <el-date-picker :readonly="true" :picker-options="datePickerRtp" format="dd-MM-yyyy" value-format="yyyy-MM-dd" v-model="formInfo.dateRapport" type="date" id="dateRapport" placeholder="Date du rapport" style="width:100%">
                                                        </el-date-picker>
                                                    </el-form-item>
                                                </v-flex>

                                                <v-flex md3>
                                                    <el-form-item label="Température" style="width:100%">
                                                        <el-input-number style="width:100%" :min="0" size="large" controls-position="right"   v-model="formInfo.temp" placeholder="Température"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>
                                            
                                                <v-flex md3>
                                                    <el-form-item label="Précipitation(mm2)" style="width:100%">
                                                        <el-input-number style="width:100%" :min="0" size="large" controls-position="right"   v-model="formInfo.pluie" placeholder="Précipitation"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>

                                                <v-flex md3>
                                                    <el-form-item label="Vent(km/h)" style="width:100%">
                                                        <el-input-number style="width:100%" :min="0" size="large" controls-position="right"   v-model="formInfo.vent" placeholder="Vitesse du vent"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>


                                            </v-layout>
                                            <v-layout row>  
                                                <v-flex md3>
                                                    <el-form-item label="Nombre d'heure de travail" required style="width:100%">
                                                        <el-input-number style="width:100%" :min="0" size="large" controls-position="right"   v-model="formInfo.heurTravail" placeholder="Nombre d'heure de travail"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>                                             
                                                 <v-flex md3>
                                                    <el-form-item label="Tronçon" required style="width:100%">
                                                        <el-input v-model="formInfo.trancon" placeholder="Tronçon" style="width:100%"></el-input>                                                       
                                                    </el-form-item>
                                                </v-flex>
                                                 <v-flex md3>
                                                    <el-form-item label="Du profil" required style="width:100%">
                                                        <el-input v-model="formInfo.profil" placeholder="Du profil" style="width:100%"></el-input>                                                       
                                                    </el-form-item>
                                                </v-flex>
                                                 <v-flex md3>
                                                    <el-form-item label="Au profil" required style="width:100%">
                                                        <el-input v-model="formInfo.auProfil" placeholder="Du profil" style="width:100%"></el-input>                                                       
                                                    </el-form-item>
                                                </v-flex>                                                
                                            </v-layout>
                                          
                                        </el-form>

                                        <v-layout>
                                            <v-spacer></v-spacer>
                                            <v-btn icons color="grey" @click="dialogRapport = false" dark>Annuler <v-icon right>close</v-icon></v-btn>

                                            <v-btn color="primary" :disabled="!verifFormInfo()" @click.native="loadPresenceOuvrier()">Continuer <v-icon right>keyboard_arrow_right</v-icon></v-btn>
                                        </v-layout>
                                    </v-card>
                                </v-stepper-content>

                                <v-stepper-content step="2">
                                    <v-card>
                                        <v-flex xs12 class="mb-2">
                                            <v-alert :value="true" outline color="primary" icon="info">
                                                Ajouter des personnes ayant visitées le chantier
                                            </v-alert>
                                        </v-flex>

                                        <el-form label-position="top" :inline="true" :model="formVisiteur" class="demo-form-inline">
                                            <v-layout row>
                                                <v-flex md2>
                                                    <el-form-item label="Nom" required style="width:100%">
                                                        <el-input   @change="handleChangeCont" v-model="formVisiteur.nom" placeholder="Nom" style="width:100%"></el-input>
<!-- 
                                                        <el-select
                                                            v-model="formVisiteur.nom"
                                                            filterable
                                                            @change="handleChangeCont"
                                                            allow-create
                                                            default-first-option
                                                            placeholder="Nom">
                                                            <el-option
                                                            v-for="cont in listeControlleur"
                                                            :key="cont.id"
                                                            :label="cont.label"
                                                            :value="cont.nom">
                                                            </el-option>
                                                        </el-select> -->


                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md3>
                                                    <el-form-item label="Prénom" required  style="width:100%">
                                                        <el-input v-model="formVisiteur.prenom" placeholder="Prénom" style="width:100%"></el-input>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md2>
                                                    <el-form-item label="Fonction" required  style="width:100%">
                                                        <el-input v-model="formVisiteur.fonction" placeholder="Fonction" style="width:100%"></el-input>
                                                    </el-form-item>
                                                </v-flex>

                                                 <v-flex md3>
                                                    <el-form-item label="Debut"  required style="width:50%" >
                                                        <el-time-select
                                                            v-model="formVisiteur.heure"
                                                            :picker-options="{
                                                                start: '00:00',
                                                                step: '00:15',
                                                                end: '23:45'
                                                            }"
                                                            placeholder="Heure debut ">
                                                            </el-time-select>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md3>
                                                    <el-form-item label="Fin"  style="width:50%" required >
                                                        <el-time-select
                                                            v-model="formVisiteur.heureFin"
                                                            :picker-options="{
                                                                start: '00:00',
                                                                step: '00:15',
                                                                end: '23:45'
                                                            }"
                                                            placeholder="Heure fin ">
                                                            </el-time-select>
                                                    </el-form-item>
                                                </v-flex>

                                                 <v-flex md2 ml-3>
                                                    <el-form-item label="Action" >
                                                        <el-button type="primary" v-if="tableVisiteur.length != 10"  :disabled="!verifFormVisiteur()" @click="addListVisiteur(formVisiteur)">Ajouter</el-button>
                                                     </el-form-item>
                                                 </v-flex>



                                            </v-layout>

                                        </el-form>
                                        <br>

                                        <v-layout row>
                                            <el-table :data="tableVisiteur" style="width: 100%">
                                                <el-table-column prop="nom" label="Nom" sortable> </el-table-column>
                                                <el-table-column prop="prenom" label="Prénom"> </el-table-column>
                                                <el-table-column prop="fonction" label="Fonction"></el-table-column>
                                                <el-table-column prop="heure" label="Heure Debut"></el-table-column>
                                                 <el-table-column prop="heureFin" label="Heure Fin"></el-table-column>
                                                <el-table-column label="Operations">
                                                    <template slot-scope="scope">
                                                        <v-tooltip top>
                                                            <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableVisiteur)" dark>
                                                                <v-icon center>delete</v-icon>
                                                            </v-btn>
                                                            Supprimer ce visiteur
                                                        </v-tooltip>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </v-layout>
                                        <br>
                                    </v-card>

                                    <v-layout row>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click.native="d1 = 1"><v-icon right>keyboard_arrow_left</v-icon> Précédent</v-btn>

                                        <v-btn color="primary"  @click.native="d1 = 3">Continuer <v-icon right>keyboard_arrow_right</v-icon></v-btn>
                                    </v-layout>
                                </v-stepper-content>

                                <v-stepper-content step="3">
                                    <v-card>
                                        <v-flex xs12 class="mb-2">
                                            <v-alert :value="true" outline color="primary" icon="info">
                                                Sécurité/Hse - SITUATIONS ENVIRONNEMENTALES ET SOCIALES
                                            </v-alert>
                                        </v-flex>

                                          <v-layout row v-for="(quest, index) in listeQualitatif" >
                                              <v-flex md4>
                                                <div class="block">
                                                  <span class="demonstration"> </span>
                                                    <el-input v-model="quest.libelle"
                                                    :prop="'listeQualitatif.' + index + '.libelle'"
                                                    name="libelle" placeholder="Question" style="width: 100%" :readonly="true"></el-input>
                                                </div>
                                              </v-flex>
                                              <v-flex md2>
                                                  <!-- <span class="demonstration">Reponse *</span> -->
                                                <el-select  default-first-option  v-model="quest.reponse" placeholder="Reponse * " style="width:100%">
                                                  <el-option
                                                        v-for="(item) in reponses"
                                                        :key="item.value"
                                                        :prop="'listeQualitatif.' + index + '.resp'"
                                                        :label="item.text"
                                                        :value="item.id">
                                                    </el-option>
                                                </el-select>
                                              </v-flex>
                                             <v-flex md3 v-if="quest.reponse == 1">
                                                  <span class="demonstration">Nombre *</span>
                                                          <el-input
                                                            type="number"
                                                            value="nombre"
                                                            :prop="'listeQualitatif.' + index + '.qte'"
                                                            placeholder="Qte"
                                                            v-model="quest.qte"
                                                            style="width:100%"
                                                          ></el-input>
                                              </v-flex>
                                             <v-flex md3 v-if="quest.reponse == 1">
                                                  <span class="demonstration">Heure *</span>
                                                            <el-time-select
                                                            style="width:100%"
                                                            v-model="quest.dateHarret"
                                                            format="HH:mm"
                                                            :prop="'listeQualitatif.' + index + '.date'"
                                                            value-format="HH:mm"
                                                            id="HeureArret"
                                                            placeholder="Selectionnez l'heure"
                                                            :picker-options="{
                                                                start: '00:00',
                                                                step: '00:05',
                                                                end: '23:55'
                                                                }"
                                                            >
                                                            </el-time-select>
                                              </v-flex>

                                            <v-flex md3 v-if="quest.reponse == 1">
                                                  <span class="demonstration">Observation *</span>
                                                        <el-input style="width:100%"
                                                          v-model="quest.description"
                                                         :prop="'listeQualitatif.' + index + '.description'"
                                                         type="textarea" :rows="6" placeholder="Observation  "></el-input>
                                              </v-flex>
                                            </v-layout>
                                    </v-card>

                                    <v-layout row>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click.native="d1 = 2"><v-icon right>keyboard_arrow_left</v-icon> Précédent</v-btn>
                                        <v-btn color="primary"  @click.native="d1 = 4" >Continuer <v-icon right>keyboard_arrow_right</v-icon></v-btn>
                                    </v-layout>
                                </v-stepper-content>
                            
                                <v-stepper-content step="4">
                                    <v-card>
                                        <v-flex xs12 class="mb-2">
                                            <v-alert :value="true" outline color="primary" icon="info">
                                                Inventaire Matériaux Utilisées

                                            </v-alert>
                                        </v-flex>
                                         <v-flex md18>
                                            <v-layout row v-for="(optionP) in optionProduit" :key="optionP.key">

                                                <v-flex md9>
                                                    <span class="demonstration">Type ressource *</span>
                                                    <el-select
                                                            v-model="optionP.produit"
                                                            filterable
                                                            v-on:change="loadUniteProduit(optionP.produit)"
                                                            style="width:100%"
                                                        >
                                                            <el-option
                                                            v-for="item in listeProduitAffich"
                                                            :key="item.id"
                                                            :id="item.id"
                                                            :label="item.value+' / '+item.type"
                                                            :value="item"
                                                            ></el-option>
                                                        </el-select>
                                                    <!-- <el-select name="valeurSelect" id="valeurSelect"  v-model="optionP.type" v-on:change="loadTypeProduit(optionP.type)" placeholder="Type ressource" style="width:100%">
                                                        <el-option v-for="item in listTypeRessource" :key="item.id" :label="item.libelle" :value="item.libelle">
                                                        </el-option>
                                                    </el-select> -->
                                                </v-flex>
                                              <!-- <v-flex  md9>
                                                <div class="block">
                                                  <span class="demonstration">Ressource *</span>
                                                  <el-select
                                                   v-model="optionP.produit"
                                                    filterable
                                                    v-on:change="loadUniteProduit(optionP.produit)"
                                                    style="width:100%"
                                                  >
                                                    <el-option
                                                      v-for="item in listeProduitAffich"
                                                      :key="item.id"
                                                      :label="item.libelle"
                                                      :value="item.value"
                                                    ></el-option>
                                                  </el-select>
                                                </div>
                                              </v-flex>                                                 -->
                                                <v-flex md4>
                                                    <div class="block">
                                                        <span class="demonstration">Quantité *</span>
                                                        <el-input type="number" min="1" v-model="optionP.qte"></el-input>
                                                    </div>
                                                </v-flex>                                                 
                                                <v-flex md4>
                                                    <div class="block">
                                                    <span class="demonstration">Unité *</span>
                                                        <el-input type="text" name="valeurSelect" :readonly="true" v-model="valeurUniteMateriel" style="width:100%"></el-input>                                                   
                                                    </div>
                                                </v-flex>
                                                <v-flex md4>
                                                    <div class="block">
                                                        <span class="demonstration">Prix unitaire *</span>
                                                        <el-input type="number" min="0" v-model="optionP.prix"></el-input>
                                                    </div>
                                                </v-flex>
                                                 <v-flex md1 class="text-xs-left">
                                                    <v-btn icons color="primary" v-if="tableInventaire.length != 10" @click="addListInventaire(optionP)" fab small dark>
                                                        <v-icon>add</v-icon>
                                                    </v-btn>
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                         <el-form label-position="top" :inline="true" :model="formInventaire" class="demo-form-inline">
                                             <br>

                                        <v-layout row>
                                            <el-table :data="tableInventaire" style="width: 100%">
                                                <el-table-column prop="type" label="Catégorie de ressource" sortable> </el-table-column>
                                                <!-- <el-table-column prop="code" label="Code Analytique" sortable> </el-table-column> -->
                                                <el-table-column prop="libelle" label="Type ressource"  sortable> </el-table-column>
                                                <el-table-column prop="qte" label="Quantité"> </el-table-column>
                                                 <el-table-column prop="unite" label="Unité"> </el-table-column>
                                                 <el-table-column prop="prix" label="Prix unitaire"> </el-table-column>

                                                <el-table-column label="Operations">
                                                    <template slot-scope="scope">
                                                        <v-tooltip top>
                                                            <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableInventaire)" dark>
                                                                <v-icon center>delete</v-icon>
                                                            </v-btn>
                                                            Supprimer
                                                        </v-tooltip>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </v-layout>
                                        </el-form>
                                        <br>
                                    </v-card>

                                    <v-layout row>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click.native="d1 = 3"><v-icon right>keyboard_arrow_left</v-icon> Précédent</v-btn>
                                        <v-btn color="primary"  @click.native="d1 = 5" >Continuer <v-icon right>keyboard_arrow_right</v-icon></v-btn>
                                    </v-layout>
                                </v-stepper-content>

                                <v-stepper-content step="5">
                                    <v-card>
                                        <v-flex xs12 class="mb-2">
                                            <v-alert :value="true" outline color="primary" icon="info">
                                                Inventaire Ressources Externes (non prévu)
                                            </v-alert>
                                        </v-flex>
                                 
                                        <el-form label-position="top" :inline="true" :model="formExternRes" class="demo-form-inline">
                                            <v-layout row>
                                                <v-flex md3>
                                                    <el-form-item label="Type" required style="width:100%">
                                                        <el-input v-model="formExternRes.type" placeholder="Type" style="width:100%"></el-input>                                                
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md3>
                                                    <el-form-item label="Libelle" required  style="width:100%">
                                                        <el-input v-model="formExternRes.libelle" placeholder="Libellé" style="width:100%"></el-input>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md3>
                                                    <el-form-item label="Quantité" required  style="width:100%">
                                                        <el-input-number style="width:100%" :min="0" size="large" controls-position="right"   v-model="formExternRes.qte" placeholder="Quantité"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md3>
                                                    <el-form-item label="Unité" required  style="width:100%">
                                                        <el-input v-model="formExternRes.unite" placeholder="Unité" style="width:100%"></el-input>
                                                    </el-form-item>
                                                </v-flex>
                                                <!-- <v-flex md3>
                                                    <el-form-item label="Coût" required  style="width:100%">
                                                        <el-input-number style="width:100%" :min="0" size="large" controls-position="right"   v-model="formExternRes.cout" placeholder="Coût d'utilisation"></el-input-number>
                                                    </el-form-item>
                                                </v-flex> -->

                                                 <v-flex md3>
                                                    <el-form-item label="Debut"  required style="width:50%" >
                                                        <el-time-select
                                                            v-model="formExternRes.heure"
                                                            :picker-options="{
                                                                start: '00:00',
                                                                step: '00:15',
                                                                end: '23:45'
                                                            }"
                                                            placeholder="Heure debut ">
                                                            </el-time-select>
                                                    </el-form-item>
                                                </v-flex>

                                                <v-flex md3>
                                                    <el-form-item label="Fin"  style="width:50%" required >
                                                        <el-time-select
                                                            v-model="formExternRes.heureFin"
                                                            :picker-options="{
                                                                start: '00:00',
                                                                step: '00:15',
                                                                end: '23:45'
                                                            }"
                                                            placeholder="Heure fin ">
                                                            </el-time-select>
                                                    </el-form-item>
                                                </v-flex>

                                                 <v-flex md2 ml-5>
                                                    <el-form-item label="Action" >
                                                        <el-button type="primary" v-if="tableformExtern.length != 10"  :disabled="!veriformExternRes()" @click="addListRessouE(formExternRes)">Ajouter</el-button>
                                                     </el-form-item>
                                                 </v-flex>
                                            </v-layout>
                                        </el-form>
                                        <br>

                                        <v-layout row>
                                            <el-table :data="tableformExtern" style="width: 100%">
                                                <el-table-column prop="type" label="Type" sortable> </el-table-column>
                                                <el-table-column prop="libelle" label="Libelle"> </el-table-column>
                                                <el-table-column prop="qte" label="Quantite"></el-table-column>
                                                <el-table-column prop="unite" label="Unité"></el-table-column>
                                                <!-- <el-table-column prop="cout" label="Coût"></el-table-column> -->
                                                <el-table-column prop="heure" label="Heure Debut"></el-table-column>
                                                 <el-table-column prop="heureFin" label="Heure Fin"></el-table-column>
                                                <el-table-column label="Operations">
                                                    <template slot-scope="scope">
                                                        <v-tooltip top>
                                                            <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableformExtern)" dark>
                                                                <v-icon center>delete</v-icon>
                                                            </v-btn>
                                                            Supprimer cette ressource
                                                        </v-tooltip>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </v-layout>
                                        <br>
                                        

                                    </v-card>

                                    <v-layout row>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click.native="d1 = 4"><v-icon right>keyboard_arrow_left</v-icon> Précédent</v-btn>                                        
                                        <v-btn color="primary" @click.native="loadOuvrierTravaux();loadRessourceTechnik();loadVehicule(); d1 = 6" >Continuer <v-icon right>keyboard_arrow_right</v-icon></v-btn>
                                    </v-layout>
                                </v-stepper-content>
 
                                <v-stepper-content step="6">
                                      <v-card>
                                        <v-flex xs12 class="mb-2 ml-2 mr-2">
                                          <v-alert
                                            :value="true"
                                            outline
                                            color="purple"
                                            icon="info"
                                          >Personnels affectés au chantier</v-alert>
                                        </v-flex>
                                         <!-- AJOUTER PRESENCE-->
                                         <ListePresence :idTravaux=detailTrx.idTrx :listeOuvriers="listePrestOuvriers" :listeData="listeData"  @dataChange="loadListePresence"  ></ListePresence>
                                          <!-- AJOUTER PRESENCE-->

                                      <!-- <el-form label-position="top" :inline="true" :model="formResoussourTechnik"  ref="formResoussourTechnik" class="demo-form-inline">
                                          <v-layout row>
                                              <v-flex md4>
                                                <el-form-item label="Fonction" required  style="width:100%" >
                                                    <el-select clearable allow-create filterable v-model="formResoussourTechnik.fonction" placeholder="Type de travailleur"    style="width:100%">
                                                        <el-option v-for="(item,index) in listeFonctions" :key= index :label="item.fonction" :value="item.fonction"></el-option>
                                                    </el-select>
                                                </el-form-item>
                                              </v-flex>

                                              <v-flex md4>
                                                  <el-form-item label="Personnes"  required style="width:100%">
                                                      <el-input-number style="width:100%" :min="0" size="large" controls-position="right"   v-model="formResoussourTechnik.nbre" placeholder="Nombre de personnes présentes"></el-input-number>
                                                  </el-form-item>
                                              </v-flex>
                                              <v-flex md2 ml-3>
                                                  <el-form-item label="Action" >
                                                      <el-button type="primary" :disabled="!verifFormRessTechnik()" @click="addRtechnik(formResoussourTechnik)">Ajouter</el-button>
                                                    </el-form-item>
                                                </v-flex>
                                          </v-layout>
                                        </el-form>
                                        <v-spacer></v-spacer>
                                        <br />

                                        <v-layout row class="ml-2 mr-2">
                                          <el-table :data="tableRessTechnik" style="width: 100%">
                                            <el-table-column prop="fonction" label="Fonction" sortable></el-table-column>
                                            <el-table-column prop="nbre" label="Personnes" sortable></el-table-column>
                                            <el-table-column label="Operations">
                                              <template slot-scope="scope">
                                                <v-tooltip top>
                                                  <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRowRessTechnik(scope.$index, tableRessTechnik)" dark>
                                                    <v-icon center>delete</v-icon>
                                                  </v-btn>Supprimer
                                                </v-tooltip>
                                              </template>
                                            </el-table-column>
                                          </el-table>
                                        </v-layout>
                                        <br /> -->
                                      </v-card>
                                    <v-layout row>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click.native="d1 = 5"><v-icon right>keyboard_arrow_left</v-icon> Précédent</v-btn>
                                        <v-btn color="primary"  @click.native="loadTache();d1 = 7">Continuer <v-icon right>keyboard_arrow_right</v-icon></v-btn> 
                                    </v-layout>
                                </v-stepper-content>

                                <v-stepper-content step="7">
                                    <v-card>
                                        <v-flex xs12 class="mb-2">
                                            <v-alert :value="true" outline color="primary" icon="info">
                                                Matériel(s) / Engin(s) affecté(s) au travaux
                                            </v-alert>
                                        </v-flex>
                                        <el-form label-position="top" :inline="true" :model="formVehicule" class="demo-form-inline">
                                            <v-layout row>
                                                <v-flex md3>
                                                    <el-form-item label="Matériel/Engin" required style="width:100%">
                                                        <el-select
                                                            filterable
                                                            @change="findCoutVehicule();calculTotalHeure()" 
                                                            v-model="formVehicule.libelle" 
                                                            placeholder="Selectionnez ou saisir le matériel " 
                                                            style="width:100%"
                                                            >
                                                            <el-option
                                                                v-for="item in listeVehicule"
                                                                :key="item.idVeh"
                                                                :label="item.matricule"
                                                                :value="item.matricule"
                                                            ></el-option>
                                                            </el-select>
                                                        <!-- <el-select   filterable  allow-create @change="findCoutVehicule();calculTotalHeure()"  default-first-option  v-model="formVehicule.libelle" placeholder="Selectionnez ou saisir le matériel " style="width:100%">
                                                            <el-option-group
                                                                    v-for="group in listeVehicule"                                                                    
                                                                    :label="group.label"
                                                                    >
                                                                <el-option
                                                                        v-for="item in group.vehicule"
                                                                        :label="item.immatriculation"
                                                                        :value="item.value">
                                                                </el-option>
                                                            </el-option-group>
                                                        </el-select> -->
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md3>
                                                    <el-form-item label="heure debut" style="width: 100%" required>
                                                       <el-time-select
                                                          v-model="formVehicule.heureDebut"
                                                          @change="calculTotalHeure()"
                                                          :picker-options="{
                                                              start: '00:00',
                                                              step: '00:15',
                                                              end: '23:45'
                                                          }"
                                                          placeholder="Heure debut "
                                                        ></el-time-select>
                                                    </el-form-item>
                                                </v-flex>

                                                <v-flex md3>
                                                    <el-form-item label="heure fin" style="width: 100%" required>
                                                       <el-time-select
                                                          v-model="formVehicule.heureFin"
                                                          @change="calculTotalHeure()"
                                                          :picker-options="{
                                                              start: '00:00',
                                                              step: '00:15',
                                                              end: '23:45'
                                                          }"
                                                          placeholder="Heure de fin "
                                                        ></el-time-select>
                                                    </el-form-item>
                                                </v-flex>


                                                <v-flex md3>
                                                    <el-form-item label="heure pause/Intemperie" style="width: 100%" required>
                                                       <el-time-select
                                                          v-model="formVehicule.heurePause"
                                                          @change="calculTotalHeure()"
                                                          :picker-options="{
                                                              start: '00:00',
                                                              step: '00:15',
                                                              end: '23:45'
                                                          }"
                                                          placeholder="Heure pause/Intemperie "
                                                        ></el-time-select>
                                                    </el-form-item>
                                                </v-flex>

                                                <v-flex md3>
                                                    <el-form-item label="heure travail" style="width: 100%">
                                                      <el-input  class="inline-input" v-model="formVehicule.heureTotal" required  :placeholder="this.totalHeureVehicule" :value="this.totalHeureVehicule" :readonly="true" style="font-size:22px" ></el-input>
                                                    </el-form-item>
                                                </v-flex>

                                            </v-layout>

                                            <v-layout row>
                                               <v-flex md3>
                                                    <el-form-item label="Compteur début jour (km/h)"  required style="width:100%">
                                                        <el-input-number v-model="formVehicule.cptDjour" placeholder="Compteur début jour" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>
                                                  <v-flex md3>
                                                    <el-form-item label="Compteur fin jour (km/h)" style="width:100%">
                                                        <el-input-number v-model="formVehicule.cptFjour" placeholder="Compteur fin jour" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>

                                                <v-flex md3>
                                                    <el-form-item label="Qte de Carburant prise (litre)"  required style="width:100%">
                                                        <el-input-number v-model="formVehicule.qte" @change="calculTotalComm()" placeholder="Quantité consommée" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>

                                                 <v-flex md3>
                                                    <el-form-item label="Prix (L) du carburant(FCFA)"  required style="width:100%">
                                                        <el-input-number v-model="formVehicule.cout" @change="calculTotalComm()" placeholder="Cout unitaire du carburant" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>
<!-- 
                                                <v-flex md3>
                                                    <el-form-item label="Coût horaire(FCFA)"  style="width:100%">
                                                        <el-input
                                                            style="font-size:22px"
                                                            :value="new Intl.NumberFormat('fr-Fr').format(formVehicule.utilisation)"
                                                            v-model="formVehicule.utilisation"
                                                            disabled
                                                    ></el-input>
                                                    </el-form-item>
                                                </v-flex>
 -->


                                            </v-layout>
                                            <v-layout row>
                                              <!-- <v-flex md3>
                                                    <el-form-item label="Montant dépensé (FCFA)" style="width:100%">
                                                       <el-input
                                                            style="font-size:22px"
                                                            :value="new Intl.NumberFormat('fr-Fr').format(formVehicule.total)"
                                                            v-model="formVehicule.total"
                                                            disabled
                                                    ></el-input>
                                                       <el-input  class="inline-input" v-model="formVehicule.total" required  :placeholder="this.formVehicule.total" :readonly="true" style="width: 100%" ></el-input>
                                                        <el-input-number v-model="formVehicule.total" :placeholder="this.formVehicule.total" style="width:100%" :readonly="true"></el-input-number>
                                                    </el-form-item>
                                                </v-flex> -->
                                              <v-flex md4>
                                                       <el-form-item style="width:100%" label="Observation"  >
                                                           <el-input style="width:100%"  type="textarea" :rows="6" placeholder="Observation  " v-model="formVehicule.description"></el-input>
                                                        </el-form-item >
                                                  </v-flex>
                                                  <v-flex md2>
                                                    <el-form-item label="Action" style="width:100%">
                                                        <el-button type="primary" :disabled="!verifFormVehicule()" @click="addListVehicule(formVehicule)">Ajouter</el-button>
                                                    </el-form-item>
                                                </v-flex>

                                            </v-layout>

                                            <br>
                                            <v-layout wrap>
                                              <v-flex md10>
                                                  <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                                      TOTAL TRAVAIL : {{totalComHT}}
                                                  </v-chip>
                                              </v-flex>
                                              <!-- <v-flex md10>
                                                  <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                                      TOTAL QUANTITE CARBURANT : {{new Intl.NumberFormat('fr-Fr').format(totalQteCarb) }} LITRE(S)
                                                  </v-chip>
                                              </v-flex> -->
                                          </v-layout>
                                          <!-- <v-layout row>
                                              <v-flex md10>
                                                  <v-chip outline text-color="primary" label color="primary" style="font-size:33px; width:100%">
                                                      TOTAL MONTANT DEPENSE: {{new Intl.NumberFormat('fr-Fr').format(totTTCFormatDepen)}} FCFA
                                                  </v-chip>
                                              </v-flex>
                                          </v-layout> -->
                                            <v-layout row>
                                                <el-table :data="tableVehicule" style="width: 100%">
                                                    <el-table-column type="expand">
                                                        <template slot-scope="props">
                                                          <p>
                                                            <b>Compteur début jour(km)</b>
                                                            : {{ props.row.cptDjour }}
                                                          </p>
                                                           <p>
                                                            <b>Compteur fin jour(km)</b>
                                                            : {{ props.row.cptFjour }}
                                                          </p>
                                                           <p>
                                                            <b>Prix (L) du  carburant (FCFA)</b>
                                                            : {{ props.row.cout }}
                                                          </p>
                                                            <p>
                                                            <b>Observation</b>
                                                            : {{ props.row.description }}
                                                          </p>
                                                        </template>
                                                    </el-table-column>
                                                    <el-table-column prop="libelle" label="Matériel/Engin" sortable> </el-table-column>
                                                    <el-table-column prop="heureDebut" label="Heure début"> </el-table-column>
                                                    <el-table-column prop="heureFin" label="Heure fin"> </el-table-column>
                                                    <el-table-column prop="heurePause" label="Heure pause"> </el-table-column>
                                                    <el-table-column prop="heureTotal" label="Heure travail"></el-table-column>
                                                    <el-table-column prop="qte" label="Qte de carburant prise<(Litre)"> </el-table-column>
                                                    <!-- <el-table-column prop="utilisation" label="Côut horaire (FCFA)"> </el-table-column>
                                                    <el-table-column prop="total" label="Montant dépensé (FCFA)"> </el-table-column> -->

                                                    <el-table-column label="Operations">
                                                        <template slot-scope="scope">
                                                            <v-tooltip top>
                                                                <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRowVehicule(scope.$index, tableVehicule)" dark>
                                                                    <v-icon center>delete</v-icon>
                                                                </v-btn>
                                                                Supprimer
                                                            </v-tooltip>
                                                        </template>
                                                    </el-table-column>
                                                </el-table>
                                            </v-layout>


                                        </el-form>
                                        <br>
                                    </v-card>

                                    <v-layout row>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click.native="d1 = 6"><v-icon right>keyboard_arrow_left</v-icon> Précédent</v-btn>
                                        <!-- <v-btn color="primary"  v-if="listeVehicule.length == 0" @click.native="loadTache();d1 = 7">Continuer <v-icon right>keyboard_arrow_right</v-icon></v-btn> -->
                                        <v-btn color="primary" @click.native="loadTache();d1 = 8">Continuer <v-icon right>keyboard_arrow_right</v-icon></v-btn>
                                    </v-layout>
                                </v-stepper-content>
                                
                                 <!-- <v-stepper-content step="7" v-if="listeVehicule.length == 0">
                                   <v-card>
                                        <v-flex xs12 class="mb-2">
                                            <v-alert :value="true" outline color="primary" icon="info">
                                                Travaux réalisés (La liste des tâches ne contient que celles en cours d'exécution)
                                            </v-alert>
                                        </v-flex>

                                        <el-form label-position="top" :inline="true" :model="formTravaux" class="demo-form-inline">
                                            <v-layout row>
                                                <v-flex md4>
                                                    <el-form-item label="Libelle" required style="width:100%">
                                                        <el-select  @change="handleChangeTrx" filterable  v-model="formTravaux.tache" placeholder="Selectionnez la tache" style="width:100%">
                                                            <el-option v-for="item in listeTaches" :key="item.idTache" :label="item.libelle" :value="item.idTache"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md3 v-if="etatSoutraitance">
                                                    <el-form-item label="Sous-traitant" style="width:80%">
                                                        <el-select allow-create v-model="formTravaux.sousTraitant"  @change="handleSelect" placeholder="Selectionnez le sous-traitant" style="width:100%">
                                                            <el-option  v-for="item in listeSouTraitant" :key="item.id" :label="item.libelle" :value="item.id"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md3>
                                                    <el-form-item label="Quantité total"  required style="width:100%">
                                                        <el-input :disabled="true"  size="large" v-model="formTravaux.qteTotal" controls-position="right"  placeholder="Quantité total" style="width:100%"></el-input>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md5>
                                                    <el-form-item label="Quantité déja effectuée"  required style="width:100%">
                                                        <el-input-number :disabled="true"  size="large" v-model="formTravaux.qteEffect" controls-position="right"  placeholder="Quantité déja effectuée" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>

                                                <v-flex md3>
                                                    <el-form-item label="Quantité (> 0)"  required style="width:100%">
                                                        <el-input-number :min="0.1"  size="large" :max="maxEvolution" :step="0.01" v-model="formTravaux.qte" controls-position="right"  placeholder="Quantité" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>

                                                 <v-flex md3>
                                                    <el-form-item label="Unité" style="width:100%">
                                                        <el-input controls-position="right" :disabled="true"   v-model="formTravaux.unite" style="width:100%"></el-input>
                                                    </el-form-item>
                                                </v-flex>


                                            </v-layout>
                                              <v-layout row>
                                                  <el-row type="flex" :gutter="20">
                                                  <el-col :span="24">
                                                      <el-upload class="upload-demo"
                                                                list-type="picture-card"
                                                                name="photo" action=""
                                                                ref="uploadFichContrat"
                                                                :auto-upload="false"
                                                                :on-change = "changeFile"
                                                                :multiple="true"  >
                                                          <img :src="logoProjet" height="142" width="142" class="lazy" alt="">
                                                      </el-upload>
                                                  </el-col>
                                                   <span>Taille inférieur à 10 Mo</span>
                                              </el-row>
                                              </v-layout>
                                             <v-layout row>
                                                     <v-flex md8>
                                                       <el-form-item style="width:100%" label="Observation"  >
                                                           <el-input style="width:100%"  type="textarea" :rows="6" placeholder="Observation  " v-model="formTravaux.description"></el-input>
                                                        </el-form-item >
                                                  </v-flex>
                                                   <v-flex md2>
                                                    <el-form-item label="Action" style="width:60%">
                                                        <el-button type="primary" :disabled="!verifFormTravaux()" @click="addListTravaux()">Ajouter</el-button>
                                                    </el-form-item>
                                                </v-flex>
                                             </v-layout>

                                        </el-form>
                                        <br>
                                                <CoolLightBox
                                                      :items="items"
                                                      :index="index"
                                                      @close="index = null"
                                              >

                                              </CoolLightBox>

                                        <v-layout row>
                                            <el-table :data="tableTravaux" style="width: 100%">
                                                 <el-table-column type="expand">
                                                    <template slot-scope="props">
                                                        <p><b>Observation</b> : {{ props.row.description }}</p>

                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="libelle" label="LILBELLE " sortable> </el-table-column>
                                                <el-table-column prop="qteEffect" label="Qte effective"></el-table-column>
                                                <el-table-column  v-if="etatSoutraitance" prop="sousTraitant" label="Sous-traitant"></el-table-column>
                                                <el-table-column prop="qte" label="qte (U)"></el-table-column>
                                                <el-table-column prop="unite" label="Unite"></el-table-column>
                                                <el-table-column prop="image" label="PHOTO">                                      
                                                    <template slot-scope="scope"  >
                                                        <v-avatar class="mr-1" v-for="(img,index) in scope.row.imageTaches" :key="index" :tile="true" size="40px" height="40px" color="grey lighten-4"> <img :src="img" alt="avatar">
                                                        </v-avatar>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="Operations">
                                                    <template slot-scope="scope">
                                                        <v-tooltip top>
                                                            <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableTravaux)" dark>
                                                                <v-icon center>delete</v-icon>
                                                            </v-btn>
                                                            Supprimer
                                                        </v-tooltip>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </v-layout>
                                        <br>
                                    </v-card>

                                    <v-layout row>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click.native="d1 = 6"><v-icon right>keyboard_arrow_left</v-icon> Précédent</v-btn>

                                        <v-btn color="green" class="white--text" :disabled="!verifTableTravaux()"  @click.native="dialogAccord = true">Enregister <v-icon right>done</v-icon></v-btn>
                                    </v-layout>
                                </v-stepper-content> -->

                                <v-stepper-content step="8" >
                                   <v-card>
                                        <v-flex xs12 class="mb-2">
                                            <v-alert :value="true" outline color="primary" icon="info">
                                                Travaux réalisés (La liste des tâches ne contient que celles en cours d'exécution)
                                            </v-alert>
                                        </v-flex>

                                        <el-form label-position="top" :inline="true" :model="formTravaux" class="demo-form-inline">
                                            <v-layout row v-if="this.tableTravaux.length <= 0">
                                                <v-flex md4 >
                                                    <el-form-item label="Activité" required style="width:100%">
                                                        <el-select filterable  v-model="formTravaux.activite" placeholder="Selectionnez la tache" style="width:100%">                                                         
                                                            <el-option v-for="item in listeActivite" :key="item.id" :label="item.libelle" :value="item.libelle"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md4 v-if="this.formTravaux.activite == 'NON'">
                                                    <el-form-item label="Description" required style="width:100%">
                                                    <el-input style="width:100%"
                                                          v-model="formTravaux.descriptionActivite"
                                                         type="textarea" :rows="6" placeholder="Observation"></el-input>
                                                    </el-form-item>
                                                </v-flex>

                                                
                                                <v-flex md4 v-if="this.formTravaux.activite == 'OUI'">
                                                    <el-form-item label="Libelle" required style="width:100%">
                                                        <el-select  @change="handleChangeTrx" filterable  v-model="formTravaux.tache" placeholder="Selectionnez la tache" style="width:100%">                                                         
                                                            <el-option v-for="item in listeTaches" :key="item.idTache" :label="item.libelle" :value="item.idTache"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </v-flex>
                                                 <v-flex md3 v-if="etatSoutraitance">
                                                    <el-form-item label="Sous-traitant" style="width:80%">
                                                        <el-select  clearable  allow-create v-model="formTravaux.sousTraitant"  @change="handleSelect" placeholder="Selectionnez le sous-traitant" style="width:100%">
                                                            <el-option  v-for="item in listeSouTraitant" :key="item.id" :label="item.libelle" :value="item.id"></el-option>
                                                        </el-select>
                                                    </el-form-item>
                                                </v-flex>
                                                
                                                <v-flex md3 v-if="this.formTravaux.activite == 'OUI'">
                                                    <el-form-item label="Quantité total"  required style="width:100%">
                                                      
                                                        <el-input :disabled="true"  size="large" v-model="formTravaux.qteTotal" controls-position="right"  placeholder="Quantité total" style="width:100%"></el-input>
                                                    </el-form-item>
                                                </v-flex>
                                                <v-flex md3 v-if="this.formTravaux.activite == 'OUI'">
                                                    <el-form-item label="Quantité déja effectuée"  required style="width:100%">
                                                        <el-input-number :disabled="true"  size="large" v-model="formTravaux.qteEffect" controls-position="right"  placeholder="Quantité déja effectuée" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>

                                                <v-flex md3 v-if="this.formTravaux.activite == 'OUI'">
                                                    <el-form-item label="Quantité"  required style="width:100%">
                                                        <el-input-number :min="0"  size="large" :max="maxEvolution" :step="0.01" v-model="formTravaux.qte" controls-position="right"  placeholder="Quantité" style="width:100%"></el-input-number>
                                                    </el-form-item>
                                                </v-flex>

                                                 <v-flex md2 v-if="this.formTravaux.activite == 'OUI'">
                                                    <el-form-item label="Unité" style="width:100%">
                                                        <el-input controls-position="right" :disabled="true"   v-model="formTravaux.unite" style="width:100%"></el-input>
                                                    </el-form-item>
                                                </v-flex>


                                            </v-layout>
                                              <v-layout row v-if="this.tableTravaux.length <= 0 && this.formTravaux.activite == 'OUI'">
                                                  <el-row type="flex" :gutter="20">
                                                  <el-col :span="24">
                                                      <el-upload class="upload-demo"
                                                                list-type="picture-card"
                                                                name="photo" action=""
                                                                ref="uploadFichContrat"
                                                                :auto-upload="false"
                                                                :on-change = "changeFile"
                                                                :multiple="true"  >
                                                          <img height="142" width="142" :src="logoProjet" class="lazy" alt="">
                                                      </el-upload>
                                                  </el-col>
                                                   <span>Taille inférieur à 10 Mo</span>
                                              </el-row>
                                              </v-layout>
                                             <v-layout row v-if="this.tableTravaux.length <= 0 && this.formTravaux.activite == 'OUI'">
                                                     <v-flex md8>
                                                       <el-form-item style="width:100%" label="Observation"  >
                                                           <el-input style="width:100%"  type="textarea" :rows="6" placeholder="Observation  " v-model="formTravaux.description"></el-input>
                                                        </el-form-item >
                                                  </v-flex>
                                                   <v-flex md2>
                                                    <el-form-item label="Action" style="width:60%">
                                                        <el-button type="primary" :disabled="!verifFormTravaux()" @click="addListTravaux()">Ajouter</el-button>
                                                    </el-form-item>
                                                </v-flex>
                                             </v-layout>

                                        </el-form>
                                        <br>
                                                <CoolLightBox
                                                      :items="items"
                                                      :index="index"
                                                      @close="index = null"
                                              >

                                              </CoolLightBox>

                                        <v-layout row v-if="this.formTravaux.activite == 'OUI'">
                                            <el-table :data="tableTravaux" style="width: 100%">
                                                 <el-table-column type="expand">
                                                    <template slot-scope="props">
                                                        <p><b>Observation</b> : {{ props.row.description }}</p>

                                                    </template>
                                                </el-table-column>
                                                <el-table-column prop="libelle" label="Libelle " sortable> </el-table-column>
                                                <el-table-column  v-if="etatSoutraitance" prop="libellSousTrai" label="Sous-traitant"></el-table-column>
                                                 <el-table-column prop="qte" label="Quantité effectuée"></el-table-column>
                                                <el-table-column prop="unite" label="Unitée"></el-table-column>
                                                <el-table-column prop="image" label="Photo">
                                                  <template slot-scope="scope">
                                                            <v-tooltip bottom>
                                                            <v-avatar
                                                                    slot="activator"
                                                                    v-for="(image, imageIndex) in scope.row.imageTaches"
                                                                    :key="imageIndex"
                                                                    @click="showDiapo(scope.row.imageTaches,imageIndex,image)"
                                                                    :style="{ backgroundImage: 'url(' + image + ')' , cursor: 'pointer'}"
                                                                    :tile=true
                                                                    :size="50"
                                                                    color="grey lighten-4"
                                                                    class="mb-1 mr-1 elevation-3"
                                                            >
                                                                <img :src="image" alt="avatar">
                                                            </v-avatar>
                                                                Cliquez pour agrandir
                                                            </v-tooltip>
                                                        </template>

                                                    <template slot-scope="scope"  >
                                                        <v-avatar class="mr-1" v-for="(img,index) in scope.row.imageTaches" :key="index" :tile="true" size="40px" height="40px" color="grey lighten-4"> <img :src="img" alt="avatar">
                                                        </v-avatar>
                                                    </template>
                                                </el-table-column>
                                                <el-table-column label="Operations">
                                                    <template slot-scope="scope">
                                                        <v-tooltip top>
                                                            <v-btn slot="activator" fab small icons color="red" @click.native.prevent="deleteRow(scope.$index, tableTravaux)" dark>
                                                                <v-icon center>delete</v-icon>
                                                            </v-btn>
                                                            Supprimer
                                                        </v-tooltip>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </v-layout>
                                        <br>
                                    </v-card>

                                    <v-layout row>
                                        <v-spacer></v-spacer>
                                        <v-btn color="primary" @click.native="d1 = 6"><v-icon right>keyboard_arrow_left</v-icon> Précédent</v-btn>

                                        <v-btn color="green" class="white--text" :disabled="!verifTableTravaux()"  @click.native="dialogAccord = true">Enregister <v-icon right>done</v-icon></v-btn>
                                    </v-layout>
                                </v-stepper-content>
                            </v-stepper-items>

                        </v-stepper>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--FIN DIALOG FORMULAIRE DEMANDE-->

        <!--  VALIDATION RAPPROT JOURNALIERS-->
        <v-dialog v-model="dialogAccord" max-width="50%" persistent>
            <v-card>
                <v-card-title class="headline">Voulez-vous valider le rapport journaliers du {{dateRaport}}</v-card-title>
                <v-card-text>
                    En cliquant sur valider, le rapport sera soumis pour validation à votre supérieur hiérarchique (Chef chantier ou Chef projet).Après la validation le rapport ne pourra plus être supprimé.Votre Supérieur peut emettre une réserve s'il estime qu'une tâche est à refaire, dans ce cas vous recevrez une notification.<br/>
                    <b>NB: Vous ne pouvez effectuer qu'un seul rapport par jour</b>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat="flat" @click.native="dialogAccord = false">Annuler</v-btn>
                    <v-btn color="green darken-1" flat="flat" @click.native="createRapport()">Valider</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--  VALIDATION RAPPROT JOURNALIERS-->

        <!--  VALIDATION RAPPROT JOURNALIERS-->
        <v-dialog v-model="dialogNewRapport" max-width="50%" persistent>
            <v-card>
                <v-card-title class="headline">Voulez-vous effectuer un autre rapport journalier pour la date du {{dateRaport}}</v-card-title>
                <v-card-text>
                    En cliquant sur NON, vous ne pourriez plus effectué de rapport journalier pour la date du {{dateRaport}} <br/>                    
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" flat="flat" @click.native="dialogNewRapport = false;dialogRapport = false">Non</v-btn>
                    <v-btn color="green darken-1" flat="flat" @click.native="createNewRapport()">Oui</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--  VALIDATION RAPPROT JOURNALIERS-->

    </div>
</template>

<script>
    import Loading from '@/components/Loading';
    import ListePresence from "@/components/boardTravaux/ListePresence";
    export default {
        components: {Loading,ListePresence},
        name: "RapportJournalier",
         props: {
            show: {
                 type: Boolean
            },
            editRapport: {
                 type: Boolean
            },
            detailTrx: {
            type: Object
            },
            dateRpt:{
                type: Date,
                default: ()=>(new Date() )
            }
        },
        data() {
            return {
                //data general
                domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
                user: JSON.parse(sessionStorage.getItem("userInfo")),
                roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
                loading: false,
                dialogRapport: false,
                e1: 1,
                d1: 1,
                items:[],
              index: null,
              dateRaport: '',
             dialogAccord: false,
             dialogNewRapport: false,

                formResoussourTechnik:{
                    fonction:'',
                    nbre:0,
                },

                //INFO
                formInfo:{
                    vent:0,
                    pluie:0,
                    temp:0,
                    heurTravail: '',
                    dateRapport:''
                },
                datePickerRtp:{
                    disabledDate(date){
                        return date > (new Date())
                    }
                },

                optionProduit: [{type:"",code:"", produit: "", qte: 1 , unite: "" }],
                //VISITEUR
                tableVisiteur:[],
                formVisiteur:{},

                // pour le ressource externe
                tableformExtern: [],
                formExternRes: {},
                //ARRET TRAVAUX
                formArret:{
                    cause:""
                },

                //INVENTAIRE
                formInventaire:{},
                tableInventaire:[],
                listeProduit:[],
                listeEtatMat:[
                    {
                     id: 1,
                     label: "Bon etat"
                    },
                    {
                     id: 2,
                     label: "Defectueux"
                    },
                    {
                     id: 3,
                     label: "En panne"
                    }
                 ],

                //vehicule affecte
                formVehicule:{},
                listeVehicule:[],
                tableVehicule:[],
                totalHeureVehicule :'',
                totalComHT:0,
                totalQteCarb:0,
                totalCouCarb:0,
                totTTCFormatDepen: 0,

                //Ressource
                formRessource:{
                     image: null
                },
                tableRessource:[],
                listeRessource:[],
                matriculVehicule: '',
                listePhotos: [],
                listeProduitAffich: [],
                valeurUniteMateriel:'',
                listTypeRessource: [],
                logoProjet: "/static/img-doc.png",
                fileRes: "",
                fichierRes:[],
                imageRes: "/static/avatar-conducteur.png",


                //TRAVAUX
                listeTaches: [],

                etatSoutraitance : false,
                tableTravaux:[],

                listeSouTraitant: [],
                formTravaux:{
                    images: [],
                    files:[]
                },
                 fileTache: "",
                 listeEtatTrx:[
                    {
                     id: 1,
                     label: "Terminé"
                    },
                    {
                     id: 2,
                     label: "En exécution"
                    }
                 ],
                 listeActivite:[
                    {
                     id: 1,
                     libelle: "OUI"
                    },
                    {
                     id: 2,
                     libelle: "NON"
                    }
                 ],
                 imageTrx: "/static/travaux.jpg",
                 imageTrx2: "/static/travaux.jpg",
                 imageTrx3: "/static/travaux.jpg",
                 imageTrx4: "/static/travaux.jpg",
                 fichierImage: [],

                 disabledEvolution: false,
                 minEvolution: 1,
                 totalVehicule: 0,
                 maxEvolution: 1,
                 listeControlleur: [],
                reponses: [
                      { text: "OUI", value: "OUI", id: 1 },
                      { text: "NON", value: "NON", id: 2 },
                    ],
                  listeQualitatif:[
                            {
                                libelle: "Nbre d'accident avec arrêt de travail",
                                reponse: "",
                                qte: "",
                                dateHarret: "",
                                description: "",
                                value: 1,
                                type: 1

                            },
                             {
                                  libelle: "Nbre d'accident sans arrêt de travail",
                                  reponse: "",
                                  qte: '',
                                  dateHarret: "",
                                  description: "",
                                  value: 2,
                                  type: 1
                            },
                             {
                                libelle: "Nbre de 1/4 d'heure Sécurité",
                                reponse: "",
                                qte: '',
                                dateHarret: "",
                                description: "",
                                value: 3,
                                type: 1
                            },
                             {
                                libelle: "Evacuation par ambulance",
                                reponse: '',
                                qte: "",
                                dateHarret: "",
                                description: "",
                                value: 4,
                                type: 2 //environnement
                            },
                            {
                                libelle: "Déversement accidentel (déchets liquide dangereux)",
                                value: 5,
                                type: 2, //environnement
                                reponse: "",
                                qte: 0,
                                dateHarret: "",
                                description: "",
                            },
                             {
                                libelle: "Passage de collecteur-transporteur de déchets",
                                value: 6,
                                reponse: "",
                                qte: 0,
                                dateHarret: "",
                                description: "",
                                type: 2 //environnement
                            },
                            {
                                libelle: "Déchets inertes produits",
                                value: 7,
                                reponse: "",
                                qte: 0,
                                dateHarret: "",
                                description: "",
                                type: 2 //environnement
                            },
                            {
                                libelle: "Déchets dangereux produits",
                                value: 8,
                                reponse: "",
                                qte: 0,
                                dateHarret: "",
                                description: "",
                                type: 2 //environnement
                            }
                 ],

                 tableQuestion:[],
                 listePrestOuvriers: [],
                 listeData: [],
                 listeFonctions: [],
                tablePresence: [],
                tableRessTechnik:[]

            }
        },
        computed: {

        },
        watch: {
            show : function(newValue, oldvalue){
                this.dialogRapport = newValue
                
                if(newValue == true){
                    this.dropdata()
                    this.d1 = 1;
                    if(this.editRapport) {
                        console.log('detailTrx',this.detailTrx)
                        console.log('dateRpt',this.dateRpt)
                        let row = this.detailTrx
                        this.formInfo.dateRapport = this.dateRpt
                        this.detailTrx.libelle = row.libTrx
                        this.resetForm()
                        console.log('detailTrx',this.detailTrx)
                       
                        //  etape 1
                        this.formInfo.temp = row.temp
                        this.formInfo.pluie = row.pluie
                        this.formInfo.vent = row.vent
                        this.formInfo.heurTravail = row.nmbreHeur
                        this.formInfo.trancon = row.trancon
                        this.formInfo.profil = row.profil
                        this.formInfo.auProfil = row.auProfil

                         //  etape 2
                        const transformedVisiteurs = row.listeVisiteurs.map(visiteur => {
                            const [nom, prenom] = visiteur.nomPrenom.split(" ");
                            return {
                                nom,
                                prenom,
                                fonction: visiteur.fonction,
                                heure: visiteur.HeureDbut,
                                heureFin: visiteur.HeureFin
                            };
                        });
                        this.tableVisiteur.push(...transformedVisiteurs)

                        this.tableInventaire.push(...row.listeMateriels) 
                        
                        this.tableformExtern.push(...row.listeExterneMateriels) 

                        const transformedTechnik = row.listeRessourtechnik.map(visiteur => {                        
                            return {
                                nom: visiteur.nomPrenom,
                                heureDbt: visiteur.heureDbt,
                                fonction: visiteur.fonction,
                                heurePause: visiteur.heurePause,
                                heureIntem: visiteur.heureIntem,
                                heureTotal: visiteur.heureTotal,
                                heureFin: visiteur.HeureFin,
                                heureSuppl: visiteur.heureSuppl,
                                descriptionSupp: visiteur.descriptionSupp,
                                description: visiteur.description,
                            };
                        });

                        this.listeData.push(...transformedTechnik) 

                        this.tableVehicule.push(...row.listeVehicules)

                        const transformedTaches = row.listeTaches.map(tache => {
                            return {
                                libelle: tache.libTache,
                                qte: tache.qte,
                                unite: tache.unite,
                                imageTaches: [...tache.photos],
                                description: tache.commentaire
                            };
                        });
                        this.tableTravaux.push(...transformedTaches) 

                    }else {
                        this.formInfo.dateRapport = this.dateRpt
                        let dateRpt = this.formInfo.dateRapport.getFullYear()+"-"+(this.formInfo.dateRapport.getMonth()+1)+"-"+this.formInfo.dateRapport.getDate()
                        this.dateRaport = dateRpt
                        this.formTravaux.unite = ''
                    }
                    this.loadTypeRessource()
                    this.loadMateriel();
                    this.loadVehicule();
                    this.loadOuvrier();
                    this.loadControlleur();
                    this.loadProduit()
                }


                console.log('editRapport',this.editRapport)
            }
        },
        methods: {
            createNewRapport() {
                this.dialogNewRapport = false
                this.dialogRapport = true
                this.dropdata()
                this.d1 = 1;
                this.formInfo.dateRapport = this.dateRpt
                this.formTravaux.unite = ''
                this.loadTypeRessource()
                this.loadMateriel();
                this.loadVehicule();
                this.loadOuvrier();
                this.loadControlleur();
                console.log('oii')
                                
                // this.d1 = 1;
                // this.formInfo = {}
                // this.formArret = {}
                // this.formInventaire = []
                // this.tableInventaire = []     
                // this.formExternRes = []           
                // this.tableVisiteur = []                
                // this.formVisiteur = [],
                // this.tableformExtern = []
                // this.tablePresence = []
                // this.formInfo.dateRapport = this.dateRpt

            },
            //vide les tableaux et champs du formulaire
            dropdata(){
                this.tableVisiteur.splice(0);
                this.tableformExtern.splice(0);
                this.tableInventaire.splice(0);
                this.tablePresence.splice(0);
                this.tableTravaux.splice(0);
                this.tableQuestion.splice(0);
                this.tableRessTechnik.splice(0);
                this.formInfo = {}
                this.formArret = {}
                this.formTravaux.tache = ''
            },
            changeFile(file,fileList){
                this.listePhotos.splice(0);
                const fileReader = new FileReader()

                for (const ind in fileList){
                    let filename = fileList[ind].name;
                    if( filename.lastIndexOf(".") <= 0 ){
                        return alert("Veuillez selectionner un  format de fichier valide ")
                    }
                    //fileReader.readAsDataURL(fileList[ind].raw)
                    this.listePhotos.push(fileList[ind].raw);
                    this.formTravaux.images.push(fileList[ind].raw)
                }
            },
             verifFormRessTechnik(){
                  if(this.formResoussourTechnik.fonction != null && this.formResoussourTechnik.nbre !=null ){
                      return true
                  }else {
                      return false
                  }
              },
              deleteRowRessTechnik(index, rows) {
                   rows.splice(index, 1);
              },
               loadTypeRessource() {
                let url =this.domaine + "product/typeRessource";
                    this.$http.get(url).then(response => {
                    if (response.body) {
                        response.body.types.forEach((item)=>{
                            if(item.libelle !='VEHICULE/ENGIN') {
                                  this.listTypeRessource.push(item)
                            }
                        });
                        this.loading = false;
                    }
                    });
                },
            addRtechnik(item) {
                    if (
                    item.fonction == null ||
                    item.fonction == "undefined"||
                    item.nbre == "undefined" ||
                    item.nbre == null
                  ) {
                    this.$message.error("Veuillez renseigner correctement les champs");
                    return;
                  }
                    this.tableRessTechnik.push({
                    fonction:item.fonction ,
                    nbre: item.nbre,
                  });
                  this.formResoussourTechnik ={

                  }
                },

            handleChangeCont(val){
                let control = this.listeControlleur.filter(elt=>{
                    if(elt.nom == val){
                        return true;
                    }
                    return false;
                });
                if( control[0] != undefined && control[0].prenom != null){
                    this.formVisiteur.prenom = control[0].prenom;
                    this.formVisiteur.fonction = control[0].fonction;
                }
            },

             handleChangeResource(res){
                if(res != undefined){
                    this.formRessource.fonction = res.profession
                }
            },



            resetForm(){
                this.tableTravaux.splice(0);
                this.tableInventaire.splice(0);
                this.tableVisiteur.splice(0);
                this.tableformExtern.splice(0);
                this.tableRessource.splice(0);
            },

             closeDialog() {
                 this.resetForm();
                  this.$emit("close");
                },
            createRapport(){
                let url = this.domaine + "journal/new";
                let data = new FormData()
                if(this.formTravaux.activite == 'NON' && this.formTravaux.descriptionActivite == undefined || this.formTravaux.descriptionActivite == 'undefined') {
                    this.$notify({
                            title: "Erreur dans l'enrregistrement",
                            message: "Veuillez saisir le motif",
                            type: "error",
                            position: "top-center"
                        });
                }else {

                //enregistrement des tables
                data.append("tableVisiteur", JSON.stringify(this.tableVisiteur) )
                data.append("tableVehicule", JSON.stringify(this.tableVehicule) )
                data.append("tableRessource", JSON.stringify(this.tablePresence) )
                data.append("tableTravaux", JSON.stringify(this.tableTravaux) )

               // LISTE DES PERSONNES RESSOURCES
                for (let prop in this.tableRessTechnik) {
                  let ligne = this.tableRessTechnik[prop];
                  data.append("persRessource[fonction][]", ligne.fonction);
                  data.append("persRessource[nbre][]", ligne.nbre);
                }

                // LISTE DES RESSOURCES EXTERNE
                for (let prop in this.tableformExtern) {
                  let ligne = this.tableformExtern[prop];
                  data.append("reExterne[type][]", ligne.type);
                  data.append("reExterne[libelle][]", ligne.libelle);
                  data.append("reExterne[unite][]", ligne.unite);
                  data.append("reExterne[qte][]", ligne.qte);
                  data.append("reExterne[cout][]", ligne.cout);
                  data.append("reExterne[heureDbt][]", ligne.heure);
                  data.append("reExterne[heureFin][]", ligne.heureFin);
                }

                // LISTE DES INVENTAIRES
                for (let prop in this.tableInventaire) {
                  let ligne = this.tableInventaire[prop];
                  data.append("inventaire[type][]", ligne.type);
                  data.append("inventaire[libelle][]", ligne.libelle);
                  data.append("inventaire[qte][]", ligne.qte);
                  data.append("inventaire[prix][]", ligne.prix);
                }

                // REPONSE AU QUESTION
                for (let prop in this.listeQualitatif) {
                    let ligne = this.listeQualitatif[prop];
                    data.append("options[reponse][]", ligne.reponse);
                    data.append("options[value][]", ligne.value);
                    data.append("options[qte][]", ligne.qte);
                    data.append("options[type][]", ligne.type);
                    data.append("options[dateHarret][]", ligne.dateHarret);
                    data.append("options[description][]", ligne.description);
                  }

                   // ENVOI TACHES
                for (let prop in this.tableTravaux) {
                    let ligne = this.tableTravaux[prop];
                    let img = this.tableTravaux[prop].imageTaches;
                    img.forEach((file=>{
                           data.append("travaux[fichierImage][]", file, file[name]);
                       }))
                    data.append("travaux[idOptTrx][]", ligne.idOptTrx);
                    data.append("travaux[libelle][]", ligne.libelle);
                    data.append("travaux[tache][]", ligne.tache);
                    data.append("travaux[soustraitant][]", ligne.sousTraitant);
                    data.append("travaux[qte][]", ligne.qte);
                    data.append("travaux[qteEffect][]", ligne.qteEffect);
                    data.append("travaux[imageTaches][]", ligne.imageTaches);
                    data.append("travaux[description][]", ligne.description);

                    img.forEach((file=>{
                           data.append("fichierImage[]", file, file[name]);
                       }))

                  }

                 //autre
                  let dateRpt = this.formInfo.dateRapport.getFullYear()+"-"+(this.formInfo.dateRapport.getMonth()+1)+"-"+this.formInfo.dateRapport.getDate()
                  data.append("dateRapport", dateRpt);
                  data.append('profil',this.formInfo.profil)
                  data.append('auProfil',this.formInfo.auProfil)
                  data.append("temp", this.formInfo.temp);
                  data.append("trancon", this.formInfo.trancon);                  
                  data.append("pluie", this.formInfo.pluie);
                  data.append("vent", this.formInfo.vent);
                  data.append("heurTravail", this.formInfo.heurTravail);
                  data.append("activite",  this.formTravaux.activite);
                  data.append("descriptionActivite",  this.formTravaux.descriptionActivite);
                  
                  data.append("idUser", this.user.id);
                  data.append("idTravaux", this.detailTrx.idTrx);

                  this.loading = true;
                  this.$http.post(url, data).then(
                    resp => {
                        this.loading = false;
                        this.$notify({
                            title: "Journal chantier enregistré",
                            message: resp.body.message,
                            type: "success",
                            position: "top-right",
                             duration: 7000
                        });
                        this.tableQuestion.splice(0);
                        this.tableTravaux.splice(0);
                        this.tableVisiteur.splice(0);
                        this.tableformExtern.splice(0);
                        this.tableInventaire.splice(0);
                        this.tableRessource.splice(0);
                        this.tableRessTechnik.splice(0);

                        this.$emit("reloadListeTrx")
                        this.closeDialog();
                        this.dialogAccord = false
                        this.dialogNewRapport = true
                    },
                    resp => {
                         this.loading = false;
                        this.$message.error(
                            "Erreur lors de l'enregistrement du journal"
                        );

                    }
                );

                }

            },
             deleteRow(index, rows) {
                rows.splice(index, 1);
            },
            deleteRowVehicule(index, rows) {
                rows.splice(index, 1);
                let tab = this.tableVehicule
                      let totalH = 0
                      let totalQteCarbu = 0
                      let totalCouCarbu = 0
                      let totalMtanDepen = 0
                    for (let index = 0; index < tab.length; index++) {
                      const element = tab[index];
                      let hr= this.TransFomrToMinut(element['heureTotal']);
                      totalH += hr
                      totalQteCarbu += element['qte'];
                      totalMtanDepen += parseFloat(element['total']);
                    }
                    this.totalComHT = this.TransFomrToHeur(totalH)
                    this.totalQteCarb= totalQteCarbu
                    this.totTTCFormatDepen= totalMtanDepen
            },
            //INFOW
            verifFormInfo(){
                if(this.formInfo.dateRapport != null  
                && this.formInfo.profil != ""  
                && this.formInfo.profil != null
                && this.formInfo.heurTravail != null
                && this.formInfo.auProfil != null  
                && this.formInfo.trancon != null ){
                    return true
                }else {
                    return false
                }
            },
            //VISITEUR
            addListVisiteur(item)
            {
                this.tableVisiteur.push({
                    nom : item.nom,
                    prenom : item.prenom,
                    fonction :  item.fonction,
                    heure: item.heure,
                    heureFin: item.heureFin
                })

                this.formVisiteur = {}
            },
            // RESSOURCE EXTERNE
            addListRessouE(item){
                this.tableformExtern.push({
                    type : item.type,
                    libelle : item.libelle,
                    unite : item.unite,
                    qte :  item.qte,
                    cout :  item.cout,
                    heure: item.heure,
                    heureFin: item.heureFin
                })

                this.formExternRes = {}
            },
            addListArret(item){
                 this.tableQuestion.push({
                    libelle : item.libelle.libelle,
                    qte : item.qte,
                    dateH : item.dateHarret,
                    description :  item.description,
                    type: item.libelle.type
                })

                this.formArret = {}
            },

            verifFormQuestion() {
                let i;
                let comp = 0
                 for (i = 0; i < this.listeQualitatif.length; i++) {

                      if(this.listeQualitatif[i].reponse != ''){
                        comp = comp + 1
                        if(comp == 8) return true
                      }else{
                          return false
                      }
                    }
            },
            verifFormVisiteur(){
                if(this.formVisiteur.nom != null && this.formVisiteur.prenom !=null && this.formVisiteur.fonction != null &&  this.formVisiteur.heure != null  ){
                    return true
                }else {
                    return false
                }
            },
            veriformExternRes() {
                if(this.formExternRes.type != null &&  this.formExternRes.libelle != null && this.formExternRes.qte !=null && this.formExternRes.heure != null &&  this.formExternRes.heureFin != null  ){
                    return true
                }else {
                    return false
                }
            },
             verifFormArret(){
                if(this.formArret.libelle != null && this.formArret.qte !=null && this.formArret.dateHarret != null &&  this.formArret.description != null  ){
                    return true
                }else {
                    return false
                }
            },
            //RESSOURCE
            addListRessource(item){
                this.tableRessource.push({
                    nom : item.nom.nom,
                    fonction :  item.fonction,
                    image: this.imageRes,
                    file: item.image
                })
                this.formRessource = {}
                this.imageRes= "";
            },
            verifFormRessource(){
                if(this.formRessource.nom != null  && this.formRessource.fonction != null ){
                    return true
                }else {
                    return false
                }
            },
             loadOuvrier() {
                this.loading = true;
                let url = this.domaine + "ouvrier/index";
                var formdata = new FormData();
                formdata.append("user", this.user.id);
                this.$http.post(url, formdata).then(
                    response => {

                        this.loading = false;
                        this.listeRessource = response.body.ouvrier;

                    },
                    response => {
                    this.loading = false;
                    }
                );
                },

                loadControlleur() {
                this.loading = true;
                let url = this.domaine + "controlleur/index";
                this.$http.get(url).then(
                        response => {
                            this.loading = false;
                            this.listeControlleur = response.body.controlleurs;
                        },
                        response => {
                        this.loading = false;
                        }
                    );
                },

                onFileResPicked(event)
                {
                    const files = event.target.files
                    let filename = files[0].name
                    if (filename.lastIndexOf(".") <= 0) {
                        return alert("Veuillez selectionner un  format de fichier valide ")
                    }
                    if( files[0].size > 10485760  ){
                        this.$message.error("La taille du fichier est supérieur à 10M");
                        return;
                    }

                    const fileReader = new FileReader()
                    fileReader.addEventListener("load", () => {
                        this.imageRes = fileReader.result
                    })

                    fileReader.readAsDataURL(files[0])
                    this.formRessource.image = files[0]
                    //this.file = files[0];
                    this.fichierRes.push(files[0]);
                },

            //INVENTAIRE
            addListInventaire(item){
                console.log('item',item)
                 this.tableInventaire.push({
                    type : item.produit.type,
                    code: item.codeGestion ? item.codeGestion : 'non defini',
                    libelle : item.produit.value,
                    idProduit : item.produit.id,
                    etat :  item.etat,
                    unite: this.valeurUniteMateriel,
                    qte: item.qte,
                    prix: item.prix
                })
                this.valeurUniteMateriel = ''
                this.optionProduit= [{type:"", code:"", produit: "", qte: 1 , unite: "" }],
                this.formInventaire = {}
            },
            verifFormInventaire(){
                if(this.formInventaire.libelle != null  && this.formInventaire.qte != null  && this.formInventaire.unite != null ){
                    return true
                }else {
                    return false
                }
            },

            //vehicule
            addListVehicule(item){
                //verifions ce vehicule fifure deja dans la liste
                let veh = this.tableVehicule.find(elt=>{
                    return elt.matricule == item.libelle
                });

                let infoVeh = this.listeVehicule.find(elt=>{
                    return elt.matricule == item.libelle
                });
                if(veh == undefined){
                    this.tableVehicule.push({
                        libelle : infoVeh.libelle,
                        heureDebut: item.heureDebut,
                        heureFin: item.heureFin,
                        matricule: infoVeh.matricule,
                        idVeh: infoVeh.idVeh,
                        heurePause: item.heurePause,
                        cptDjour: item.cptDjour,
                        cptFjour: item.cptFjour,
                        qte: item.qte,
                        cout:item.cout,
                        utilisation: item.utilisation,
                        total: item.total,
                        totalForma: item.total.replace(/\s/g, ''),
                        heureTotal: this.totalHeureVehicule,
                        description : item.description
                    })
                      let tab = this.tableVehicule
                      let totalH = 0
                      let totalQteCarbu = 0
                      let totalCouCarbu = 0
                      let totalMtanDepen = 0
                    for (let index = 0; index < tab.length; index++) {

                      const element = tab[index];
                      let hr= this.TransFomrToMinut(element['heureTotal']);
                      totalH += hr
                      totalQteCarbu += element['qte'];
                      totalMtanDepen += parseFloat(element['total'].replace(/\s/g, ''));
                    }
                    this.totalComHT = this.TransFomrToHeur(totalH)
                    this.totalQteCarb= totalQteCarbu
                    this.totTTCFormatDepen= totalMtanDepen
                }
                else{
                    this.$message.warning(
                        "Cet véhicule a déjà été renseignée"
                    );
                }
                this.matriculVehicule = ''
                this.formVehicule = {}
                this.totalHeureVehicule = ''
            },
            findCoutVehicule(){
              let libelle = this.formVehicule.libelle
              let resultat = 0
                this.listeVehicule.forEach(element => {
                    if(element.ref == libelle){
                        this.matriculVehicule = element.immatriculation
                        resultat = element.valeur
                    }  
                //   let elementFound = element.vehicule.find(prod => {
                //     this.matriculVehicule = prod.immatriculation
                //       return prod.value == libelle;
                //     });
                //     resultat = elementFound.valeur
                // return elementFound.valeur
              });            
              this.formVehicule.utilisation = new Intl.NumberFormat('fr-Fr').format(resultat)
            },
             TransFomrToMinut(item){
              let tabDateDbt = item.split(":"); //[00:00"]
              let hr = tabDateDbt[0];
              let min = tabDateDbt[1];
              let minute;

              minute = parseFloat(hr * 60 ) + parseFloat(min);
              return minute;
          } ,
          TransFomrToHeur(item){
              let heure;
              let minute;
              heure = Math.floor((item / 60));
              minute = parseFloat(item - (heure* 60));

              return (minute != 0)?heure+':'+minute:heure+':'+'00';
          } ,
          calculTotalHeure(){

            let maxDate = this.formVehicule.heureFin
            let minDate = this.formVehicule.heureDebut
            if(maxDate != null && minDate != null){
                let heureDebut = this.TransFomrToMinut(this.formVehicule.heureDebut)
                let heureFin = this.TransFomrToMinut(this.formVehicule.heureFin)

                let dureeMinute = heureFin - heureDebut;
                // 480 minute equivaut a 8h de travail
                // if(dureeMinute <= 480){
                     let heurePause = this.TransFomrToMinut(this.formVehicule.heurePause)
                     let hr = parseFloat(heureFin) - parseFloat(heureDebut) -parseFloat(heurePause)
                      this.totalHeureVehicule =  this.TransFomrToHeur(hr)
                // }else{
                //   this.$notify({
                //           title: "Enregistrement",
                //           message: "l'heure total de travail ne doit dépasser 8h",
                //           type: "error",
                //           position: "top-right",
                //           duration: 4000
                //       });
                //       this.formVehicule.heureFin =''
                // }

            }
          },
            calculTotalComm () {
              let HeurUtil
                let totalHVehiCHn = this.totalHeureVehicule.split(":"); //[00:00"]
                if(totalHVehiCHn[1] == "00"){
                  HeurUtil = totalHVehiCHn[0]
                }else{
                  HeurUtil = (totalHVehiCHn[0] + totalHVehiCHn[1]) / 100
                }



                this.totComLigneTTC = 0
                let couTutilisation = this.formVehicule.utilisation.replace(/\s/g, '')
                let qte = this.formVehicule.qte
                let coutCarBur = this.formVehicule.cout

                let totalHTRS = parseInt(qte * coutCarBur)
                let totalTVA = parseInt(couTutilisation * HeurUtil)
                let totalRemise = 0
                let depense = totalHTRS + totalTVA

                this.formVehicule.total =  new Intl.NumberFormat('fr-Fr').format(depense)
            },

            verifFormVehicule(){
                if(this.formVehicule.libelle != null  && this.formVehicule.qte != null  && this.formVehicule.heureDebut != null && this.formVehicule.heureFin != null ){
                    return true
                }else {
                    return false
                }
            },
             loadMateriel() {
                this.loading = true;
                let url = this.domaine + "product/product-list/materiel/type";
                var formdata = new FormData();
                formdata.append("user", this.user.id);
                this.$http.post(url, formdata).then(
                    response => {
                    if (response.body) {
                        this.loading = false;
                        this.listeProduit = response.body.produits;
                    }
                    },
                    response => {
                    this.loading = false;
                    }
                );
                },

            loadVehicule() {
                this.loading = true;
                // let url = this.domaine + "product/product-list/vehicule/travaux/"+this.detailTrx.idTrx;

                let type = 'flotte'
                let url = this.domaine +'parc/index/type'+'/'+type
                var formdata = new FormData();
                formdata.append("user", this.user.id);
                this.$http.post(url, formdata).then(
                    response => {
                        if (response.body) {
                            this.loading = false;
                            this.listeVehicule = response.body.vehicule;                        
                        }
                    },
                    response => {
                        this.loading = false;
                    }
                );
            },

            //TRAVAUX
            addListTravaux(){
                let item = this.formTravaux;

                //verifions si ces travaux n'ont pas deja ete selectionne
                let opt = this.tableTravaux.find(elt=>{
                    return elt.idTache == item.tache
                });

                if(opt == undefined){
                    //  pour la tache
                    let valeur =''
                    valeur = this.listeTaches.find(function(element) {
                        if (element.idTache == item.tache) {
                        return element;
                        }
                    });

                    // pour la tache soustraiter
                    let fourn =''
                    if(this.listeSouTraitant.length > 0) {
                            fourn = this.listeSouTraitant.find(function(element) {
                            if (element.id == item.sousTraitant) {
                            return element;
                            }
                        });
                    }
                    
                     this.tableTravaux.push({
                        libelle : valeur.libelle,
                        idOptTrx : valeur.opt.idOptTrx,
                        idTache : item.idTache,
                        qteEffect :  item.qteEffect,
                        libellSousTrai : fourn ? fourn.libelle : '',
                        soustraitant :  item.soustraitant,
                        qte: item.qte,
                        unite: item.unite,
                        files: item.files,
                        images: item.images,
                        evolution: item.evolution,
                        description : item.description,
                        imageTaches: this.listePhotos
                    })
                }
                else{
                    this.$message.error(
                            "Cette tâche a déjà été renseignée"
                        );
                }

              this.$refs.uploadFichContrat.clearFiles()
              this.listePhotos=[];
              this.formTravaux.libelle = null;
              this.formTravaux.libelle = null;
              this.formTravaux.qte = 0;
              this.formTravaux.qteEffect = null;
              this.formTravaux.description = '';

                //this.formTravaux.evolution = null;
            },
             showDiapo(images, ind,image){
                this.items = images
                this.index = ind;
            },
            handleSelect(id)
            {
                if(id == '' || id == null) {
                    this.handleChangeTrx(this.formTravaux.tache)
                }else {
                    this.formTravaux.qteTotal = 0
                    let valeur =''
                    console.log('listeSouTraitant',listeSouTraitant)
                    valeur = this.listeSouTraitant.find(function(element) {
                        if (element.id == id) {
                        return element;
                        }
                    });
                    this.formTravaux.qteTotal = valeur.qte
                    this.formTravaux.qteEffect = valeur.qteRapport;
                    this.maxEvolution = valeur.qteRestante;
                }
             
                // if(val == "Terminé")
                // {
                //     this.formTravaux.evolution = 100;
                //     this.disabledEvolution = true;
                // }else if(val == "En exécution")
                // {
                //     this.disabledEvolution = false;
                // }
            },
            handleChangeTrx(opt){
                console.log('opt',opt)
                let valeur =''   
                if(opt){  
                    valeur = this.listeTaches.find(function(element) {
                        if (element.idTache == opt) {
                        return element;
                        }
                    });
                    console.log('valeur',valeur)
                 this.listeSouTraitant =  valeur.listSoustraitant.info ? valeur.listSoustraitant.info : 0
                 this.minEvolution = valeur.opt.evolution
                 this.maxEvolution = valeur.opt.maxEvolution
                 this.formTravaux.qteEffect = valeur.opt.qteEffect;                 
                 this.formTravaux.unite = valeur.opt.unite;
                 this.formTravaux.qteTotal = valeur.opt.qteTotal
                }
            },
             onFileTachePicked(event)
            {
                this.formTravaux.images.splice(0,1);
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0) {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }
                 if( files[0].size > 10485760  ){
                        this.$message.error("La taille du fichier est supérieur à 10M");
                        return;
                    }


                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                    this.formTravaux.images.push(fileReader.result)
                })

                fileReader.readAsDataURL(files[0])
                this.formTravaux.files.push(files[0])
                this.file = files[0];
                 this.fichierImage.push(files[0])
            },
             onFileTachePicked2(event)
            {
                this.formTravaux.images.splice(1,1);
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0) {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }
                 if( files[0].size > 10485760  ){
                        this.$message.error("La taille du fichier est supérieur à 10M");
                        return;
                    }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                   this.formTravaux.images.push(fileReader.result)
                })

                fileReader.readAsDataURL(files[0])
                this.formTravaux.files.push(files[0])
                this.file = files[0];
                 this.fichierImage.push(files[0]);
            },
             onFileTachePicked3(event)
            {
                this.formTravaux.images.splice(2,1);
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0) {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }
                 if( files[0].size > 10485760  ){
                        this.$message.error("La taille du fichier est supérieur à 10M");
                        return;
                    }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                   this.formTravaux.images.push(fileReader.result)
                })

                fileReader.readAsDataURL(files[0])
                this.formTravaux.files.push(files[0])

                 this.fichierImage.push(files[0]);
            },
             onFileTachePicked4(event)
            {
                this.formTravaux.images.splice(3,1);
                const files = event.target.files
                let filename = files[0].name
                if (filename.lastIndexOf(".") <= 0) {
                    return alert("Veuillez selectionner un  format de fichier valide ")
                }
                 if( files[0].size > 10485760  ){
                        this.$message.error("La taille du fichier est supérieur à 10M");
                        return;
                    }

                const fileReader = new FileReader()
                fileReader.addEventListener("load", () => {
                     this.formTravaux.images.push(fileReader.result)

                })

                fileReader.readAsDataURL(files[0])
                this.formTravaux.files.push(files[0])

                 this.fichierImage.push(files[0]);

            },
            verifFormTravaux(){
                 if(this.formTravaux.tache != null && this.formTravaux.qte >= 0 ){
                    return true
                }else {
                    return false
                }
            },
             verifTableTravaux(){
                if(this.formInfo.dateRapport) {
                    let dateRpt = this.formInfo.dateRapport.getDate()+"-"+(this.formInfo.dateRapport.getMonth()+1)+"-"+this.formInfo.dateRapport.getFullYear()
                    this.dateRaport = dateRpt
                }
                if(this.tableTravaux.length != 0 || this.formTravaux.activite == 'NON' ){
                    return true
                }else {
                    return false
                }
            },
             loadTache() {
                this.loading = true;
                let url = this.domaine + "tache/travaux/cours/"+this.detailTrx.idTrx;
                var formdata = new FormData();
         
                formdata.append("user", this.user.id);
                formdata.append("dateRapport", this.dateRaport);
                this.$http.post(url, formdata).then(
                    response => {

                        this.loading = false;
                        this.listeTaches = response.body.taches;
                        this.etatSoutraitance = response.body.etatSoustraitance

                        if(this.listeTaches.length == 0){
                            this.$message.error("Aucune tâche en cours ou planifiées pour ces travaux");
                        }

                    },
                    response => {
                    this.loading = false;
                    }
                );
                },

                loadPresenceOuvrier(){
                    if( this.tableRessource.length > 0){
                         this.d1 = 2;
                         return;
                    }
                    this.loading = true
                    let url = this.domaine + 'ouvrier/present/travaux/'+this.detailTrx.idTrx
                    let data = new FormData();
                    let dateRpt = this.formInfo.dateRapport.getFullYear()+"-"+this.formInfo.dateRapport.getMonth()+"-"+this.formInfo.dateRapport.getDate()
                    data.append("dateRapport", dateRpt);
                    this.$http.post(url,data).then(response => {
                        this.tableRessource = response.body.ouvriers
                        this.d1 = 2;
                        this.loading = false;
                    },
                    error =>{
                        this.loading = false;
                        this.d1 = 2;
                        this.$message.error('Chargement de la liste des ouvriers presents en cours')
                    })
          },
          addOptionP() {
                this.optionProduit.push({
                    key: Date.now(),
                    type: "",
                    code:"",
                    produit: "",
                    qte: 1,
                    unite: "",
                });
            },
          loadUniteProduit(item){
            console.log('item',item)
                // let valeur
                //   valeur = this.listeProduitAffich.find(function (element) {
                //       if (element.value == item) {
                //         return element.unite;                        
                //       }
                //     });
                  this.valeurUniteMateriel = item.unite
            },
            loadProduit() {
                let url = "";
                this.loading = true;
                url = this.domaine + "product/product-list";
                this.$http.get(url).then(response => {
                if (response.body) {
                    this.loading = false;                    
                    this.listeProduitAffich = response.body;                    
                }
                });
            },

            loadTypeProduit(item){
            if (this.$refs.typeProduit == "") {
                return;
              }
              this.loading = true;
              let url = this.domaine + "product/productSelect/type/"+item;
              this.$http.get(url).then(
                response => {
                  this.loading = false;
                  this.listeProduitAffich = response.body.produits;
                },
                errRep => {
                  this.loading = false;
                  this.$message.error(
                    "Une erreur est survenue lors du chargement de la liste du chntier"
                  );
                }
              );

            },

           loadOuvrierTravaux() {
                //this.prestataireSelect.datePresence = null;
                //prestataireSelect.idC = null;
                this.loading = true;
                let url = this.domaine + "ouvrier/travaux/" + this.detailTrx.idTrx;
                this.$http.get(url).then(
                    response => {
                    this.listePrestOuvriers = response.body.ouvriers;
                    this.loading = false;
                    },
                    error => {
                    this.loading = false;
                    this.$message.error(
                        "Echec lors du chargement de la liste des ouvriers"
                    );
                    }
                );
                },
          loadRessourceTechnik() {
                this.loading = true;
                let url = this.domaine + "journal/listFonction";
                this.$http.get(url).then(
                    response => {
                    this.listeFonctions = response.body.fonction;
                    this.loading = false;
                    },
                    error => {
                    this.loading = false;
                    this.$message.error(
                        "Echec lors du chargement de la liste des ouvriers"
                    );
                    }
                );
                },


          resetFormRapprot(){
              this.tableRessource.splice(0)
          },

            loadListePresence(liste){
                this.tablePresence = liste;
            }


        },
        mounted() {
        }
    };
</script>
<style scoped>
    #stepper {
        display: flex !important;;
        overflow: visible !important;;
    }



// WEBPACK FOOTER //
// src/components/boardChantier/RapportJournalier.vue